import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

const MATERIAL_MODULES = [MatIconModule]
@NgModule({
    exports: MATERIAL_MODULES,
    imports: MATERIAL_MODULES,
})
export class LegalMaterialModule {}
